import React from "react";
import { GLOBAL_IMAGES } from "../assets/asset"; 

const SubscriptionPage = () => {

  const handleGetStarted = (planType) => {
   console.log(planType)
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center font-mali overflow-hidden"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`, 
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="bg-white bg-opacity-50  py-3 rounded-lg shadow-lg px-24">
        <h2 className="text-5xl font-bold text-center mb-4">
          Free trial for 7 days
        </h2>
        <p className="text-center font-medium text-xl mb-6">
          Cancel anytime you want
        </p>

        <div className="flex justify-center gap-12">
          <div className="bg-white p-5 rounded-lg shadow-md w-72 text-left">
            <h3 className="text-xl w-fit p-2 font-bold bg-[#D9EA49] rounded-md mb-3">
              Monthly
            </h3>
            <p className="text-gray-700 mb-3 ">
              A monthly subscription is an ideal choice for you in various
              situations:
            </p>
            <ul className="list-disc list-inside text-left text-primary-dark-blue font-medium mb-4 mt-1 ">
              <li>Flexibility</li>
              <li>Short-Term Learning Goals</li>
              <li>Budget Constraints</li>
              <li>Appraisal Period</li>
            </ul>
            <div className="flex items-center justify-between">
              <p className="text-base font-bold mb-3">
                <span className="text-2xl">$15 </span>/ per month
              </p>
              <p className="text-xs text-white p-2 bg-gray-600 rounded-md">
                No Discount
              </p>
            </div>
            <button
              className=" text-primary-dark-blue border-[1px] w-full mt-4 shadow-sm shadow-primary-dark-blue border-primary-dark-blue font-mulish font-bold text-xl py-2 px-3 rounded-lg hover:bg-black/5 transition"
              onClick={() => handleGetStarted("Monthly")}
            >
              Get Started
            </button>
          </div>

          <div className="bg-white p-5 rounded-lg shadow-md w-72 text-left">
            <h3 className="text-xl w-fit p-2 font-bold bg-[#D9EA49] rounded-md mb-3">
              Yearly
            </h3>
            <p className="text-gray-700 mb-3 ">
              A yearly subscription is an ideal choice you in various situations
            </p>
            <ul className="list-disc list-inside text-left text-primary-dark-blue font-medium mb-4 mt-1 ">
              <li>Cost Efficiency</li>
              <li>Long-Term Commitment</li>
              <li>Reduced Hassle</li>
              <li>Consistent Learning</li>
            </ul>
            <div className="flex items-center justify-between">
              <p className="text-base font-bold mb-3">
                <span className="text-2xl">$12 </span>/ per month
              </p>
              <p className="text-xs p-2 bg-[#D9EA49] font-mulish font-extrabold rounded-md">
                SAVE 20%
              </p>
            </div>
            <button
              className=" text-white  w-full mt-4 shadow-sm hover:bg-blue-800  bg-primary-dark-blue font-mulish font-bold text-xl py-2 px-3 rounded-lg  transition"
              onClick={() => handleGetStarted("Monthly")}
            >
              Get Started
            </button>
          </div>
        </div>

        <div className="text-center mt-6">
          <button
            className=" text-primary-dark-blue border-2 w-96 mt-4 shadow-sm hover:bg-white/20 border-primary-dark-blue font-mulish font-bold text-xl py-2 px-3 rounded-lg hover:bg-blue-800 transition"
            onClick={() => handleGetStarted("Monthly")}
          >
            Start my 7 day free trial
          </button>
          <p className="mt-4 text-xs font-mulish text-gray-600">
            Already purchased?{" "}
            <a href="#" className="text-blue-600 underline">
              Restore
            </a>
          </p>
          <a
            href="#"
            className="font-mulish block mt-1 text-xs text-gray-500 underline"
          >
            Read Subscription terms
          </a>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPage;
